<template>
	<div v-if="visible" class="fd-event-recurrence" :class="clazz" :style="style">
		<div v-if="isRecurr" class="recurr-border"></div>

		<div class="fd-widget">
			<div class="app-field pos-wide">
				<select style="z-index: 1" v-model="masterType" :disabled="ro">
					<option value="no">{{ env.msg('repeatedEvents.donotrepeat') }}</option>
					<option value="daily">{{ env.msg('repeatedEvent.daily') }}</option>
					<option value="weekly">{{ env.msg('repeatedEvent.weekly') }}</option>
					<option value="monthly">{{ env.msg('repeatedEvent.monthly') }}</option>
					<option value="yearly">{{ env.msg('repeatedEvent.yearly') }}</option>
				</select>
			</div>
		</div>

		<div v-if="Array.isArray(errors) && errors.length > 0" class="fd-widget">
			<widget-errors :errors="errors"></widget-errors>
		</div>

		<template v-if="isRecurr">
			<template v-if="masterType === 'daily'">
				<div class="fd-widget">
					<div class="app-field pos-wide">
						<label class="mixed-input">
							<input type="radio" v-model="subType" value="nth-day" :disabled="ro">
							<span>{{ env.msg('repeatedEvent.every') }}</span>
							<span><input type="number" v-model.number="day" :class="['rep-interval', dayErrorClass]" @change="subType='nth-day'" :readonly="ro">.</span>
							<span>{{ env.msg('unit.day.one') }}</span>
						</label>
					</div>
				</div>
				<div class="fd-widget">
					<div class="app-field pos-wide">
						<label class="mixed-input">
							<input type="radio" v-model="subType" value="workday" :disabled="ro">
							<span>{{ env.msg('repeatedEvent.everyWorkday') }}</span>
						</label>
					</div>
				</div>
			</template>
			<template v-if="masterType === 'weekly'">
				<div class="fd-widget">
					<div class="app-field pos-wide">
						<label class="mixed-input-no-radio">
							<span>{{ env.msg('repeatedEvent.repeatEvery') }}</span>
							<span><input type="number" v-model.number="week" :class="['rep-interval', weekErrorClass]" :readonly="ro">.</span>
							<span>{{ env.msg('repeatedEvent.weekAt') }}</span>
						</label>
					</div>
				</div>
				<div class="fd-widget">
					<div class="app-field pos-wide">
						<div class="week-names-grid">
							<label class="nw"><input type="checkbox" v-model="value.monday" :disabled="ro"> {{ env.msg('bas.mon') }}</label>
							<label class="nw"><input type="checkbox" v-model="value.tuesday" :disabled="ro"> {{ env.msg('bas.tue') }}</label>
							<label class="nw"><input type="checkbox" v-model="value.wednesday" :disabled="ro"> {{ env.msg('bas.wed') }}</label>
							<label class="nw"><input type="checkbox" v-model="value.thursday" :disabled="ro"> {{ env.msg('bas.thu') }}</label>
							<label class="nw"><input type="checkbox" v-model="value.friday" :disabled="ro"> {{ env.msg('bas.fri') }}</label>
							<label class="nw"><input type="checkbox" v-model="value.saturday" :disabled="ro"> {{ env.msg('bas.sat') }}</label>
							<label class="nw"><input type="checkbox" v-model="value.sunday" :disabled="ro"> {{ env.msg('bas.sun') }}</label>
						</div>
					</div>
				</div>
			</template>
			<template v-if="masterType === 'monthly'">
				<div class="fd-widget">
					<div class="app-field pos-wide">
						<label class="mixed-input">
							<input type="radio" v-model="subType" value="monthly-every" :disabled="ro">
							<span class="flow-nb">
								<span>{{ env.msg('repeatedEvent.every') }}</span>
								<span><input type="number" v-model.number="day" :class="['rep-interval', dayErrorClass]" @change="subType='monthly-every'" :readonly="ro">.</span>
								<span>{{ env.msg('repeatedEvent.dayInEvery') }}</span>
							</span>
							<span class="flow-nb">
								<span><input type="number" v-model.number="month" :class="['rep-interval', monthErrorClass]" @change="subType='monthly-every'" :readonly="ro">.</span>
								<span>{{ env.msg('repeatedEvent.month') }}</span>
							</span>
						</label>
					</div>
				</div>
				<div class="fd-widget">
					<div class="app-field pos-wide">
						<label class="mixed-input">
							<input type="radio" v-model="subType" value="monthly-always" :disabled="ro">
							<span class="flow-nb">
								<span>{{ env.msg('repeatedEvent.always') }}</span>
								<select v-model.number="week" @change="subType='monthly-always'" :class="[weekErrorClass]" :disabled="ro">
									<option :value="1">{{ env.msg('repeatedEvent.1') }}</option>
									<option :value="2">{{ env.msg('repeatedEvent.2') }}</option>
									<option :value="3">{{ env.msg('repeatedEvent.3') }}</option>
									<option :value="4">{{ env.msg('repeatedEvent.4') }}</option>
									<option :value="8">{{ env.msg('repeatedEvent.last').toLowerCase() }}</option>
								</select>
								<select v-model.number="day" @change="subType='monthly-always'" :class="[dayErrorClass]" :disabled="ro">
									<option :value="0">{{ env.msg('list.segment.day').toLowerCase() }}</option>
									<option :value="1">{{ env.msg('bas.mon').toLowerCase() }}</option>
									<option :value="2">{{ env.msg('bas.tue').toLowerCase() }}</option>
									<option :value="3">{{ env.msg('bas.wed').toLowerCase() }}</option>
									<option :value="4">{{ env.msg('bas.thu').toLowerCase() }}</option>
									<option :value="5">{{ env.msg('bas.fri').toLowerCase() }}</option>
									<option :value="6">{{ env.msg('bas.sat').toLowerCase() }}</option>
									<option :value="7">{{ env.msg('bas.sun').toLowerCase() }}</option>
									<option :value="8">{{ env.msg('repeatedEvent.workDay').toLowerCase() }}</option>
								</select>
							</span>
							<span class="flow-nb">
								<span>{{ env.msg('repeatedEvent.inEvery') }}</span>
								<span><input type="number" v-model.number="month" :class="['rep-interval', monthErrorClass]" @change="subType='monthly-always'" :readonly="ro">.</span>
								<span>{{ env.msg('repeatedEvent.month') }}</span>
							</span>
						</label>
					</div>
				</div>

			</template>
			<template v-if="masterType === 'yearly'">
				<div class="fd-widget">
					<div class="app-field pos-wide">
						<label class="mixed-input">
							<input type="radio" v-model="subType" value="anniversary" :disabled="ro">
							<span class="flow-nb">
								<span>{{ env.msg('list.segment.day') }}</span>
								<span><input type="number" v-model.number="day" :class="['rep-interval', dayErrorClass]" @change="subType='anniversary'" min="1" max="31" :readonly="ro">.</span>
								<select v-model.number="month" @change="subType='anniversary'" :class="[monthErrorClass]" :disabled="ro">
									<option :value="1">{{ env.msg('calendar.january').toLowerCase() }}</option>
									<option :value="2">{{ env.msg('calendar.february').toLowerCase() }}</option>
									<option :value="3">{{ env.msg('calendar.march').toLowerCase() }}</option>
									<option :value="4">{{ env.msg('calendar.april').toLowerCase() }}</option>
									<option :value="5">{{ env.msg('calendar.may').toLowerCase() }}</option>
									<option :value="6">{{ env.msg('calendar.june').toLowerCase() }}</option>
									<option :value="7">{{ env.msg('calendar.july').toLowerCase() }}</option>
									<option :value="8">{{ env.msg('calendar.august').toLowerCase() }}</option>
									<option :value="9">{{ env.msg('calendar.september').toLowerCase() }}</option>
									<option :value="10">{{ env.msg('calendar.october').toLowerCase() }}</option>
									<option :value="11">{{ env.msg('calendar.november').toLowerCase() }}</option>
									<option :value="12">{{ env.msg('calendar.december').toLowerCase() }}</option>
								</select>
							</span>
							<span class="flow-nb">
								<span>{{ env.msg('repeatedEvent.anniv').toLowerCase() }}</span>
								<select v-model.number="anniversary" @change="subType='anniversary'" :disabled="ro">
									<option :value="0">-</option>
									<option :value="1" key="anniversary.birthday">{{ env.msg('anniversary.birthday').toLowerCase() }}</option>
									<option :value="2" key="anniversary.nameDay">{{ env.msg('anniversary.nameDay').toLowerCase() }}</option>
									<option :value="3" key="anniversary.birthOfChild">{{ env.msg('anniversary.birthOfChild').toLowerCase() }}</option>
									<option :value="4" key="anniversary.foundation">{{ env.msg('anniversary.foundation').toLowerCase() }}</option>
									<option :value="5" key="anniversary.marriage">{{ env.msg('anniversary.marriage').toLowerCase() }}</option>
									<option :value="6" key="anniversary.others">{{ env.msg('anniversary.others').toLowerCase() }}</option>
								</select>
							</span>
						</label>
					</div>
				</div>
				<div class="fd-widget">
					<div class="app-field pos-wide">
						<label class="mixed-input">
							<input type="radio" v-model="subType" value="yearly" :disabled="ro">
							<span class="flow-nb">
								<span>{{ env.msg('repeatedEvent.always') }}</span>
								<select v-model.number="week" @change="subType='yearly'" :class="[weekErrorClass]" :disabled="ro">
									<option :value="1">{{ env.msg('repeatedEvent.1') }}</option>
									<option :value="2">{{ env.msg('repeatedEvent.2') }}</option>
									<option :value="3">{{ env.msg('repeatedEvent.3') }}</option>
									<option :value="4">{{ env.msg('repeatedEvent.4') }}</option>
									<option :value="8">{{ env.msg('repeatedEvent.last').toLowerCase() }}</option>
								</select>
								<select v-model.number="day" @change="subType='yearly'" :class="[dayErrorClass]" :disabled="ro">
									<option :value="0">{{ env.msg('list.segment.day').toLowerCase() }}</option>
									<option :value="1">{{ env.msg('bas.mon').toLowerCase() }}</option>
									<option :value="2">{{ env.msg('bas.tue').toLowerCase() }}</option>
									<option :value="3">{{ env.msg('bas.wed').toLowerCase() }}</option>
									<option :value="4">{{ env.msg('bas.thu').toLowerCase() }}</option>
									<option :value="5">{{ env.msg('bas.fri').toLowerCase() }}</option>
									<option :value="6">{{ env.msg('bas.sat').toLowerCase() }}</option>
									<option :value="7">{{ env.msg('bas.sun').toLowerCase() }}</option>
									<option :value="8">{{ env.msg('repeatedEvent.workDay').toLowerCase() }}</option>
								</select>
							</span>
							<span class="flow-nb">
								<span>{{ env.msg('repeatedEvent.ofMonth') }}</span>
								<select v-model.number="month" @change="subType='yearly'" :class="[monthErrorClass]" :disabled="ro">
									<option :value="1">{{ env.msg('calendar.january').toLowerCase() }}</option>
									<option :value="2">{{ env.msg('calendar.february').toLowerCase() }}</option>
									<option :value="3">{{ env.msg('calendar.march').toLowerCase() }}</option>
									<option :value="4">{{ env.msg('calendar.april').toLowerCase() }}</option>
									<option :value="5">{{ env.msg('calendar.may').toLowerCase() }}</option>
									<option :value="6">{{ env.msg('calendar.june').toLowerCase() }}</option>
									<option :value="7">{{ env.msg('calendar.july').toLowerCase() }}</option>
									<option :value="8">{{ env.msg('calendar.august').toLowerCase() }}</option>
									<option :value="9">{{ env.msg('calendar.september').toLowerCase() }}</option>
									<option :value="10">{{ env.msg('calendar.october').toLowerCase() }}</option>
									<option :value="11">{{ env.msg('calendar.november').toLowerCase() }}</option>
									<option :value="12">{{ env.msg('calendar.december').toLowerCase() }}</option>
								</select>
							</span>
						</label>
					</div>
				</div>
			</template>

			<div class="fd-widget">
				<div class="app-field pos-wide">{{ env.msg('repeatedEvent.range') }}:</div>
			</div>
			<div class="fd-widget">
				<div class="app-field pos-wide">
					<label class="mixed-input">
						<input type="radio" v-model.number="limit" :value="0" :disabled="ro">
						<span>{{ env.msg('repeatedEvent.nolimits') }}</span>
					</label>
				</div>
			</div>
			<div class="fd-widget">
				<div class="app-field pos-wide">
					<label class="mixed-input">
						<input type="radio" v-model.number="limit" :value="1" :disabled="ro">
						<span>{{ env.msg('repeatedEvent.limit') }}</span>
						<span><input type="number" v-model.number="occurrence" :class="['rep-interval', occurErrorClass]" min="2" :readonly="ro"></span>
						<span>{{ env.msg('repeatedEvent.occurrence') }}</span>
					</label>
				</div>
			</div>
			<div class="fd-widget">
				<div class="app-field pos-wide">
					<label class="mixed-input">
						<input type="radio" v-model.number="limit" :value="2" :disabled="ro">
						<span>{{ env.msg('repeatedEvent.dateLimit') }}</span>
						<span><temporal-part :data="value" :part="dateLimitPart" :viewmode="vm" :readonly="ro" :class="[dateLimitErrorClass]"></temporal-part></span>
					</label>
				</div>
			</div>

		</template>
	</div>
</template>

<script setup lang="ts">
import {computed, ref, watch} from "vue";
import useEditor, {type EditorProps, editorProps} from "@fd/editors/Editor.ts";
import type {EventRecurrence} from "@t/fd/editor/EventRecurrence.ts";
import {injectEnv} from "@fd/Environment.ts";
import {Recurrence, RecurrenceType} from "@t/event/Event.ts";
import TemporalPart from "@fd/editors/temporal/TemporalPart.vue";
import {Temporal} from "@t/fd/editor/Temporal.ts";
import WidgetErrors from "@fd/containers/WidgetErrors.vue";
import type {Input} from "@t/fd/editor/Input.ts";

const uprops = defineProps({...editorProps});
const props = uprops as EditorProps;

const er = computed<EventRecurrence>(() => props.part as EventRecurrence);
const {visible, value, ro, vm, clazz, style, errors, errorClassFields } = useEditor(props);
const env = injectEnv();

const dayErrorClass = computed<string>(() => errorClassFields("rep_day"));
const weekErrorClass = computed<string>(() => errorClassFields("rep_week"));
const monthErrorClass = computed<string>(() => errorClassFields("rep_month"));
const yearErrorClass = computed<string>(() => errorClassFields("rep_year"));
const occurErrorClass = computed<string>(() => errorClassFields("occur"));
const dateLimitErrorClass = computed<string>(() => errorClassFields("dateLimit"));

const isRecurr = computed<boolean>(() => {
	return value.value?.type >  RecurrenceType.NO;
});
const masterType = computed<string>({
	get():string {
		const repeat = value.value as Recurrence;
		if (typeof repeat === "object") {
			switch (repeat.type) {
				case RecurrenceType.NTH_DAY:
				case RecurrenceType.WORKDAY:
					return "daily";
				case RecurrenceType.WEEKLY:
					return "weekly";
				case RecurrenceType.MONTHLY_EVERY:
				case RecurrenceType.MONTHLY_ALWAYS:
					return "monthly";
				case RecurrenceType.ANNIVERSARY:
				case RecurrenceType.YEARLY:
					return "yearly";
			}
		}
		return "no";
	},
	set(v:string):void {
		if (typeof value.value !== "object") value.value = {};
		switch (v) {
			case "no":
				value.value.type = RecurrenceType.NO;
				break;
			case "daily":
				value.value.type = RecurrenceType.NTH_DAY;
				break;
			case "weekly":
				value.value.type = RecurrenceType.WEEKLY;
				break;
			case "monthly":
				value.value.type = RecurrenceType.MONTHLY_EVERY;
				break;
			case "yearly":
				value.value.type = RecurrenceType.ANNIVERSARY;
				break;
		}
	}
});
const subType = computed<string>({
	get():string {
		const repeat = value.value as Recurrence;
		if (typeof repeat === "object") {
			switch (repeat.type) {
				case RecurrenceType.NTH_DAY:
					return "nth-day";
				case RecurrenceType.WORKDAY:
					return "workday";
				case RecurrenceType.WEEKLY:
					return "weekly";
				case RecurrenceType.MONTHLY_EVERY:
					return "monthly-every";
				case RecurrenceType.MONTHLY_ALWAYS:
					return "monthly-always";
				case RecurrenceType.ANNIVERSARY:
					return "anniversary";
				case RecurrenceType.YEARLY:
					return "yearly";
			}
		}
		return "no";
	},
	set(v:string):void {
		if (typeof value.value !== "object") value.value = {};
		switch (v) {
			case "nth-day":
				value.value.type = RecurrenceType.NTH_DAY;
				break;
			case "workday":
				value.value.type = RecurrenceType.WORKDAY;
				break;
			case "weekly":
				value.value.type = RecurrenceType.WEEKLY;
				break;
			case "monthly-every":
				value.value.type = RecurrenceType.MONTHLY_EVERY;
				break;
			case "monthly-always":
				value.value.type = RecurrenceType.MONTHLY_ALWAYS;
				break;
			case "anniversary":
				value.value.type = RecurrenceType.ANNIVERSARY;
				break;
			case "yearly":
				value.value.type = RecurrenceType.YEARLY;
				break;
		}
	}
});

function setRecur(setter:(r:Recurrence)=>void) {
	if (typeof value.value !== "object") value.value = {};
	setter(value.value as Recurrence);
}

function getRecur<T>(getter:(r:Recurrence)=>T, defalt:T) {
	const repeat = value.value as Recurrence;
	if (typeof repeat === "object") {
		let val = getter(repeat);
		return val ?? defalt;
	}
	return defalt;
}

const day = computed<number>({
	get():number {
		return getRecur((r) => r.day, 1);
	},
	set(v:number):void {
		setRecur((r) => r.day = v);
	}
});

const week = computed<number>({
	get():number {
		return getRecur((r) => r.week, 1);
	},
	set(v:number):void {
		setRecur((r) => r.week = v);
	}
});

const month = computed<number>({
	get():number {
		return getRecur((r) => r.month, 1);
	},
	set(v:number):void {
		setRecur((r) => r.month = v);
	}
});

const anniversary = computed<number>({
	get():number {
		return getRecur((r) => r.anniversary, 1);
	},
	set(v:number):void {
		setRecur((r) => r.anniversary = v);
	}
});

const limit = computed<number>({
	get():number {
		return getRecur((r) => r.limit, 0);
	},
	set(v:number):void {
		setRecur((r) => r.limit = v);
	}
});


const occurrence = computed<number>({
	get():number {
		return getRecur((r) => r.occurrence, 2);
	},
	set(v:number):void {
		setRecur((r) => r.occurrence = v);
	}
});
watch(occurrence, () => limit.value = 1);

const dateLimitPart:Temporal = {
	type: "temporal",
	timePolicy: 0,	// DATE
	property: "dateLimit"
};
watch(() => value.value?.dateLimit, (dl) => {
	limit.value = dl ? 2 : 0;
});

</script>

<style>
.fd-event-recurrence {
	display: grid;
	grid-column: 1 / -1;
	grid-template-columns: subgrid;
	align-items: baseline;
	row-gap: calc(2 * var(--form-v-padding));
	column-gap: calc(2 * var(--form-h-padding));
	position: relative;
	--next-left-gutter: var(--form-left-gutter);
	--next-right-gutter: var(--form-right-gutter);
	padding-bottom: 8px;
}


.recurr-border {
	border-radius: var(--form-v-start-padding);
	position: absolute;
	z-index: 0;
	border: 1px solid var(--border-color);
	top: calc(var(--input-height) / 2);
	bottom: 0;
	right: calc(var(--form-right-gutter) / -2 - 1px);
	left: calc(var(--form-left-gutter) / -2 - 1px);
	pointer-events: none;
	transition: border-color 500ms;
}

/**
	Use for segments of inputs flow which are unbreakable
 */
.flow-nb {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	column-gap: var(--input-spacing);
	align-items: baseline;
	justify-content: flex-start;
}

.mixed-input-no-radio,
.mixed-input {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	row-gap: calc(var(--form-v-padding) * 2);
	column-gap: var(--input-spacing);
	align-items: baseline;
	justify-content: flex-start;
}
.mixed-input {
	padding-left: 1.5em;
	position:relative;

	& > input[type=radio]:first-child {
		position: absolute;
		top: 4px;
		left: 2px;
	}
}

.rep-interval {
	max-width: 4em;
}
.week-names-grid {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	column-gap: 16px;
}
@container (width < 400px) {
	.week-names-grid {
		grid-template-columns: 1fr 1fr 1fr;
	}
}
</style>